import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getToken, getProfile } from "../Storage/Storage"; // Assuming getUserRole fetches the user's role

function NotFoundWrapper() {
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuthAndRedirect = async () => {
      const token = await getToken();
      if (token) {
        // User is authenticated, now check their role
        const role = await getProfile(); // Fetch the user's role

        // Redirect based on role
        if (role === "Student") {
          navigate("/learner");
        } else if (role === "Teacher") {
          navigate("/teacher");
        } else if (role === "Moderator") {
          navigate("/moderator/video-management");
        }
      } else {
        // If not authenticated, redirect to the landing page
        navigate("/");
      }
    };

    checkAuthAndRedirect();
  }, [navigate]);

  return null; // No content needed since we are redirecting
}

export default NotFoundWrapper;
